// import React, { useState, useEffect } from 'react';
// import { 
//   FiPlus, 
//   FiHash, 
//   FiUser, 
//   FiFileText, 
//   FiMessageSquare,
//   FiTrash2,
//   FiShield,
//   FiAlertCircle,
//   FiLock,
//   FiCheck
// } from "react-icons/fi";
// import { message } from "antd";
// import { getAccessToken } from "../../token"; 
// import { API_URL } from "../../Constants"; 

// // --- Helper Components ---
// const FormInput = ({ label, icon: Icon, readOnly, ...props }) => (
//   <div className="group">
//     {label && (
//       <label className="block text-xs font-bold text-slate-500 uppercase tracking-wide mb-1.5 ml-1">
//         {label}
//       </label>
//     )}
//     <div className="relative">
//       <input
//         {...props}
//         readOnly={readOnly}
//         className={`w-full pl-10 pr-4 py-2.5 rounded-lg border text-sm outline-none transition-all
//           ${readOnly 
//             ? "bg-slate-100 border-slate-200 text-slate-500 cursor-not-allowed" 
//             : "bg-slate-50 border-slate-200 text-slate-800 focus:ring-2 focus:ring-[#009cde] focus:border-[#009cde] focus:bg-white hover:border-[#009cde]"
//           }`}
//       />
//       <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none text-slate-400 group-focus-within:text-[#009cde] transition-colors">
//         {Icon && <Icon size={16} />}
//       </div>
//     </div>
//   </div>
// );

// const FormTextArea = ({ label, icon: Icon, ...props }) => (
//   <div className="group">
//     <label className="block text-xs font-bold text-slate-500 uppercase tracking-wide mb-1.5 ml-1">
//       {label}
//     </label>
//     <div className="relative">
//       <textarea
//         {...props}
//         className="w-full pl-10 pr-4 py-2.5 rounded-lg border border-slate-200 bg-slate-50 text-sm text-slate-800 placeholder-slate-400 focus:ring-2 focus:ring-[#009cde] focus:border-[#009cde] focus:bg-white outline-none transition-all hover:border-[#009cde] resize-none"
//       />
//       <div className="absolute top-3 left-3 pointer-events-none text-slate-400 group-focus-within:text-[#009cde] transition-colors">
//         {Icon && <Icon size={16} />}
//       </div>
//     </div>
//   </div>
// );

// // --- JWT Decoder Helper ---
// const getUserIdFromToken = (token) => {
//   try {
//     if (!token) return null;
//     const payload = token.split('.')[1];
//     if (!payload) return null;
//     const decodedPayload = JSON.parse(atob(payload));
//     return decodedPayload.userId || decodedPayload.id || decodedPayload.sub || null;
//   } catch (error) {
//     console.error('Error decoding token:', error);
//     return null;
//   }
// };

// // --- Main Component ---
// export const Configuration = () => {
//   const token = getAccessToken();
//   const [userId, setUserId] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const [isUpdating, setIsUpdating] = useState(false);

//   // Main State (Reflects Backend Data)
//   const [config, setConfig] = useState({
//     peId: "",
//     senderIds: [],
//     templateIds: [],
//     templates: []
//   });

//   // Temporary Input States (User Input)
//   const [tempPeId, setTempPeId] = useState("");
//   const [newSenderId, setNewSenderId] = useState("");
//   const [newTemplateId, setNewTemplateId] = useState("");
//   const [newTemplate, setNewTemplate] = useState("");

//   // 1. Initialize User ID from Token
//   useEffect(() => {
//     if (token) {
//       const extractedUserId = getUserIdFromToken(token);
//       if (extractedUserId) {
//         setUserId(extractedUserId);
//       } else {
//         message.error('Authentication error: Unable to identify user');
//         setIsLoading(false);
//       }
//     } else {
//       setIsLoading(false);
//     }
//   }, [token]);

//   // 2. Fetch Configuration (GET) - FIXED FOR NESTED DATA
//   const fetchConfiguration = async () => {
//     if (!userId || !token) {
//       setIsLoading(false);
//       return;
//     }

//     setIsLoading(true);
//     try {
//       const response = await fetch(`${API_URL}/api/v1/users/${userId}/sms-gateway`, {
//         method: "GET",
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       if (response.ok) {
//         const jsonResponse = await response.json();
        
//         // Critical Fix: Access the nested 'data' object
//         const configData = jsonResponse.data || {};

//         setConfig({
//           peId: configData.peId || "",
//           senderIds: configData.senderIds || [],
//           templateIds: configData.templateIds || [],
//           templates: configData.templates || []
//         });
//       } else if (response.status === 404) {
//         // No config exists yet
//         setConfig({ peId: "", senderIds: [], templateIds: [], templates: [] });
//       } else {
//         throw new Error(`Failed to fetch configuration: ${response.status}`);
//       }
//     } catch (error) {
//       console.error("Error fetching configuration:", error);
//       message.error("Failed to load DLT configuration");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (userId) fetchConfiguration();
//   }, [userId]);

//   // 3. Universal Save Function (PUT with Partial Payload)
//   // This sends ONLY the changed field to the backend
//   const updatePartialConfig = async (payload, successMessage) => {
//     if (!userId || !token) {
//       message.error('User not authenticated');
//       return false;
//     }

//     setIsUpdating(true);
//     try {
//       const response = await fetch(`${API_URL}/api/v1/users/${userId}/sms-gateway`, {
//         method: "PUT",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify(payload),
//       });

//       if (response.ok) {
//         message.success(successMessage || "Updated successfully");
//         // Immediately fetch fresh data from backend to update the UI boxes
//         await fetchConfiguration(); 
//         return true;
//       } else {
//         const errorData = await response.json().catch(() => ({}));
//         throw new Error(errorData.message || `Failed to update: ${response.status}`);
//       }
//     } catch (error) {
//       console.error("Error updating configuration:", error);
//       message.error(error.message || "Failed to update configuration");
//       return false;
//     } finally {
//       setIsUpdating(false);
//     }
//   };

//   // --- Field Specific Logic ---

//   // PE ID: Only save if one doesn't exist
//   const handleSavePeId = async () => {
//     if (!tempPeId.trim()) return;
//     const success = await updatePartialConfig({ peId: tempPeId.trim() }, "PE ID saved successfully");
//     if (success) setTempPeId("");
//   };

//   // Sender IDs: Calculate new array -> PUT -> GET
//   const handleAddSenderId = async () => {
//     const val = newSenderId.trim();
//     if (!val) return;
//     if (config.senderIds.includes(val)) {
//       message.warning('This Sender ID already exists');
//       return;
//     }
    
//     // Combine current backend data + new item
//     const updatedList = [...config.senderIds, val];
    
//     const success = await updatePartialConfig({ senderIds: updatedList }, "Sender ID added");
//     if (success) setNewSenderId("");
//   };

//   const handleRemoveSenderId = async (indexToRemove) => {
//     // Filter out the item
//     const updatedList = config.senderIds.filter((_, index) => index !== indexToRemove);
//     await updatePartialConfig({ senderIds: updatedList }, "Sender ID removed");
//   };

//   // Template IDs: Calculate new array -> PUT -> GET
//   const handleAddTemplateId = async () => {
//     const val = newTemplateId.trim();
//     if (!val) return;
//     if (config.templateIds.includes(val)) {
//       message.warning('This Template ID already exists');
//       return;
//     }

//     const updatedList = [...config.templateIds, val];
    
//     const success = await updatePartialConfig({ templateIds: updatedList }, "Template ID added");
//     if (success) setNewTemplateId("");
//   };

//   const handleRemoveTemplateId = async (indexToRemove) => {
//     const updatedList = config.templateIds.filter((_, index) => index !== indexToRemove);
//     await updatePartialConfig({ templateIds: updatedList }, "Template ID removed");
//   };

//   // Templates: Calculate new array -> PUT -> GET
//   const handleAddTemplate = async () => {
//     const val = newTemplate.trim();
//     if (!val) return;
//     if (config.templates.includes(val)) {
//       message.warning('This Template already exists');
//       return;
//     }

//     const updatedList = [...config.templates, val];
    
//     const success = await updatePartialConfig({ templates: updatedList }, "Template added");
//     if (success) setNewTemplate("");
//   };

//   const handleRemoveTemplate = async (indexToRemove) => {
//     const updatedList = config.templates.filter((_, index) => index !== indexToRemove);
//     await updatePartialConfig({ templates: updatedList }, "Template removed");
//   };

//   // --- Render ---

//   if (!token) {
//     return (
//       <div className="min-h-screen bg-[#F5F7FA] p-6 font-sans flex items-center justify-center">
//         <div className="text-center">
//           <FiAlertCircle className="text-red-500 mx-auto text-4xl mb-4" />
//           <h2 className="text-xl font-bold text-slate-800 mb-2">Authentication Required</h2>
//         </div>
//       </div>
//     );
//   }

//   if (isLoading) {
//     return (
//       <div className="min-h-screen bg-[#F5F7FA] p-6 font-sans flex items-center justify-center">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#009cde]"></div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-[#F5F7FA] p-6 font-sans">
//       <div className="max-w-6xl mx-auto">
        
//         {/* Header */}
//         <div className="mb-8">
//           <h1 className="text-2xl font-bold text-[#003087]">DLT Configuration</h1>
//           <p className="text-sm text-slate-500 mt-1">
//             Manage your Telecom Regulatory Authority (TRAI) DLT settings
//           </p>
//         </div>

//         {/* Main Content */}
//         <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
//           <div className="p-8">
            
//             {/* --- PE ID Section --- */}
//             <div className="mb-8">
//               <div className="flex items-center gap-2 mb-4">
//                 <span className="w-8 h-8 rounded-lg bg-[#e1f5fe] text-[#009cde] flex items-center justify-center">
//                   <FiHash size={16} />
//                 </span>
//                 <h3 className="text-lg font-semibold text-slate-800">Principal Entity ID</h3>
//               </div>
              
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                 <div>
//                   {config.peId ? (
//                     // Display Mode (Read Only) - Shown if PE ID exists in backend
//                     <div className="group">
//                       <label className="block text-xs font-bold text-slate-500 uppercase tracking-wide mb-1.5 ml-1">
//                         Registered PE ID
//                       </label>
//                       <div className="relative">
//                         <div className="w-full pl-10 pr-4 py-2.5 rounded-lg border border-slate-200 bg-slate-100 text-sm text-slate-600 font-mono">
//                           {config.peId}
//                         </div>
//                         <div className="absolute inset-y-0 left-3 flex items-center text-slate-400">
//                           <FiLock size={16} />
//                         </div>
//                         <div className="absolute inset-y-0 right-3 flex items-center text-green-500 gap-1 text-xs font-medium">
//                           <FiCheck /> Verified
//                         </div>
//                       </div>
//                       <p className="text-xs text-amber-600 mt-2 ml-1 flex items-center gap-1">
//                         <FiLock size={12} /> This field cannot be edited once set.
//                       </p>
//                     </div>
//                   ) : (
//                     // Edit Mode (Add New) - Shown ONLY if PE ID is empty/null
//                     <div className="flex gap-2 items-end">
//                       <div className="flex-1">
//                         <FormInput
//                           label="Set PE ID"
//                           value={tempPeId}
//                           onChange={(e) => setTempPeId(e.target.value)}
//                           placeholder="Enter PE ID"
//                           icon={FiShield}
//                         />
//                       </div>
//                       <button
//                         onClick={handleSavePeId}
//                         disabled={!tempPeId.trim() || isUpdating}
//                         className="mb-[1px] px-4 py-2.5 bg-[#003087] text-white rounded-lg font-bold text-sm hover:bg-[#001c64] disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
//                       >
//                         {isUpdating ? "..." : "Save"}
//                       </button>
//                     </div>
//                   )}
//                 </div>
                
//                 {/* Helper Box */}
//                 <div className="bg-blue-50 rounded-lg p-4 border border-blue-100">
//                   <div className="flex items-start gap-3">
//                     <FiAlertCircle className="text-blue-500 mt-0.5 flex-shrink-0" />
//                     <div>
//                       <h4 className="text-sm font-semibold text-blue-800">Important</h4>
//                       <p className="text-xs text-blue-600 mt-1">
//                         Your Principal Entity ID is permanent. Ensure it matches your TRAI registration exactly before saving.
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="h-px bg-slate-100 my-8"></div>

//             {/* --- Sender IDs Section --- */}
//             <div className="space-y-8">
//               <div>
//                 <div className="flex items-center justify-between mb-4">
//                   <div className="flex items-center gap-2">
//                     <span className="w-8 h-8 rounded-lg bg-[#e5f6ea] text-[#0c8843] flex items-center justify-center">
//                       <FiUser size={16} />
//                     </span>
//                     <h3 className="text-lg font-semibold text-slate-800">Sender IDs</h3>
//                   </div>
//                   <span className="text-xs font-medium text-slate-500 bg-slate-100 px-2 py-1 rounded">
//                     {config.senderIds.length} registered
//                   </span>
//                 </div>

//                 <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//                   {/* Add Input */}
//                   <div>
//                     <div className="flex gap-2">
//                       <FormInput
//                         label="Add New Sender ID"
//                         value={newSenderId}
//                         onChange={(e) => setNewSenderId(e.target.value)}
//                         placeholder="e.g., COMPANY"
//                         icon={FiUser}
//                       />
//                       <button
//                         onClick={handleAddSenderId}
//                         disabled={!newSenderId.trim() || isUpdating}
//                         className="mt-6 px-4 py-2.5 bg-[#003087] text-white rounded-lg font-bold text-sm hover:bg-[#001c64] disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
//                       >
//                         {isUpdating ? <div className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full" /> : <FiPlus size={16} />}
//                       </button>
//                     </div>
//                   </div>

//                   {/* List from Backend */}
//                   <div>
//                     <label className="block text-xs font-bold text-slate-500 uppercase tracking-wide mb-2 ml-1">
//                       Active Sender IDs
//                     </label>
//                     <div className="max-h-48 overflow-y-auto border border-slate-200 rounded-lg">
//                       {config.senderIds.length === 0 ? (
//                         <div className="text-center py-8 text-slate-400 text-sm">No sender IDs found</div>
//                       ) : (
//                         <div className="divide-y divide-slate-100">
//                           {config.senderIds.map((senderId, index) => (
//                             <div key={index} className="flex items-center justify-between p-3 hover:bg-slate-50">
//                               <span className="text-sm font-medium text-slate-800 ml-2">{senderId}</span>
//                               <button
//                                 onClick={() => handleRemoveSenderId(index)}
//                                 disabled={isUpdating}
//                                 className="text-red-500 hover:text-red-700 p-1 rounded transition-colors disabled:opacity-30"
//                               >
//                                 <FiTrash2 size={14} />
//                               </button>
//                             </div>
//                           ))}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* --- Template IDs Section --- */}
//               <div>
//                 <div className="flex items-center justify-between mb-4">
//                   <div className="flex items-center gap-2">
//                     <span className="w-8 h-8 rounded-lg bg-[#fff4e5] text-[#ff8c00] flex items-center justify-center">
//                       <FiFileText size={16} />
//                     </span>
//                     <h3 className="text-lg font-semibold text-slate-800">Template IDs</h3>
//                   </div>
//                   <span className="text-xs font-medium text-slate-500 bg-slate-100 px-2 py-1 rounded">
//                     {config.templateIds.length} registered
//                   </span>
//                 </div>

//                 <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//                   {/* Add Input */}
//                   <div>
//                     <div className="flex gap-2">
//                       <FormInput
//                         label="Add New Template ID"
//                         value={newTemplateId}
//                         onChange={(e) => setNewTemplateId(e.target.value)}
//                         placeholder="e.g., TMPL_OTP_001"
//                         icon={FiFileText}
//                       />
//                       <button
//                         onClick={handleAddTemplateId}
//                         disabled={!newTemplateId.trim() || isUpdating}
//                         className="mt-6 px-4 py-2.5 bg-[#003087] text-white rounded-lg font-bold text-sm hover:bg-[#001c64] disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
//                       >
//                         {isUpdating ? <div className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full" /> : <FiPlus size={16} />}
//                       </button>
//                     </div>
//                   </div>

//                   {/* List from Backend */}
//                   <div>
//                     <label className="block text-xs font-bold text-slate-500 uppercase tracking-wide mb-2 ml-1">
//                       Active Template IDs
//                     </label>
//                     <div className="max-h-48 overflow-y-auto border border-slate-200 rounded-lg">
//                       {config.templateIds.length === 0 ? (
//                         <div className="text-center py-8 text-slate-400 text-sm">No template IDs found</div>
//                       ) : (
//                         <div className="divide-y divide-slate-100">
//                           {config.templateIds.map((templateId, index) => (
//                             <div key={index} className="flex items-center justify-between p-3 hover:bg-slate-50">
//                               <span className="text-sm font-mono text-slate-800 ml-2">{templateId}</span>
//                               <button
//                                 onClick={() => handleRemoveTemplateId(index)}
//                                 disabled={isUpdating}
//                                 className="text-red-500 hover:text-red-700 p-1 rounded transition-colors disabled:opacity-30"
//                               >
//                                 <FiTrash2 size={14} />
//                               </button>
//                             </div>
//                           ))}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* --- Templates Section --- */}
//               <div>
//                 <div className="flex items-center justify-between mb-4">
//                   <div className="flex items-center gap-2">
//                     <span className="w-8 h-8 rounded-lg bg-[#f0e6ff] text-[#8b5cf6] flex items-center justify-center">
//                       <FiMessageSquare size={16} />
//                     </span>
//                     <h3 className="text-lg font-semibold text-slate-800">Message Templates</h3>
//                   </div>
//                   <span className="text-xs font-medium text-slate-500 bg-slate-100 px-2 py-1 rounded">
//                     {config.templates.length} templates
//                   </span>
//                 </div>

//                 <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//                   {/* Add Input */}
//                   <div>
//                     <FormTextArea
//                       label="Add New Template"
//                       value={newTemplate}
//                       onChange={(e) => setNewTemplate(e.target.value)}
//                       placeholder="Enter template content..."
//                       icon={FiMessageSquare}
//                       rows={4}
//                     />
                    
//                     {/* Character Counter */}
//                     <div className="flex justify-between items-center mt-2">
//                       <div className="text-xs text-slate-500 ml-1">
//                         Character count: {newTemplate.length} 
//                         <span className="ml-2 font-medium">
//                           (Max 160 for English, 70 for Hindi)
//                         </span>
//                       </div>
//                       <button
//                         onClick={handleAddTemplate}
//                         disabled={!newTemplate.trim() || isUpdating}
//                         className="flex items-center gap-2 px-4 py-2 bg-[#003087] text-white rounded-lg font-bold text-sm hover:bg-[#001c64] disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
//                       >
//                         {isUpdating ? "Saving..." : <><FiPlus size={14} /> Add Template</>}
//                       </button>
//                     </div>

//                     {/* Language Info */}
//                     <div className="mt-3 p-3 bg-amber-50 rounded-lg border border-amber-200">
//                       <div className="flex items-start gap-2">
//                         <FiAlertCircle className="text-amber-500 mt-0.5 flex-shrink-0" size={14} />
//                         <div>
//                           <p className="text-xs font-medium text-amber-800">
//                             Template Guidelines:
//                           </p>
//                           <ul className="text-xs text-amber-700 mt-1 list-disc list-inside space-y-1">
//                             <li>English templates: 160 characters per SMS</li>
//                             <li>Hindi/Unicode templates: 70 characters per SMS</li>
//                             <li>Use variables like {"{name}"}, {"{otp}"}, {"{date}"} for dynamic content</li>
//                             <li>All templates must be approved on DLT platform first</li>
//                           </ul>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   {/* List from Backend */}
//                   <div>
//                     <label className="block text-xs font-bold text-slate-500 uppercase tracking-wide mb-2 ml-1">
//                       Active Templates
//                     </label>
//                     <div className="max-h-64 overflow-y-auto border border-slate-200 rounded-lg">
//                       {config.templates.length === 0 ? (
//                         <div className="text-center py-8 text-slate-400 text-sm">No templates found</div>
//                       ) : (
//                         <div className="divide-y divide-slate-100">
//                           {config.templates.map((template, index) => (
//                             <div key={index} className="p-3 hover:bg-slate-50 group">
//                               <div className="flex items-start justify-between">
//                                 <span className="text-sm text-slate-800 break-words flex-1 mr-2">{template}</span>
//                                 <button
//                                   onClick={() => handleRemoveTemplate(index)}
//                                   disabled={isUpdating}
//                                   className="text-red-500 hover:text-red-700 p-1 rounded transition-colors disabled:opacity-30"
//                                 >
//                                   <FiTrash2 size={14} />
//                                 </button>
//                               </div>
//                             </div>
//                           ))}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Configuration;